import React from 'react';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { homePageStyles } from '../../css/style';
import ChartSkeleton from './ChartSkeleton';
import Typography from '@material-ui/core/Typography/Typography';

const styles = homePageStyles();

const LineChart = (props) => {
  const {
    data, legend, options, isLoading, isComingSoon,
  } = props;

  const chartProps = {
    data,
    legend,
    options,
    isComingSoon,
  };

  const mainLineChart = <Line {...chartProps} />;

  const chart = isComingSoon
    ? <ComingSoon chart={mainLineChart} />
    : mainLineChart;

  const chartOrSkeleton = isLoading ? <ChartSkeleton /> : chart;

  return (
    <div style={styles.relativeParentDivForResizingChart}>
      {chartOrSkeleton}
    </div>
  );
};

LineChart.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  legend: PropTypes.objectOf(PropTypes.any),
  options: PropTypes.objectOf(PropTypes.any),
};

LineChart.defaultProps = {
  height: 300,
  width: 600,
  legend: null,
  options: null,
};

const ComingSoon = ({ chart }) => {
  return (
    <div style={styles.relativeParentDivForResizingChart}>
      <div style={styles.comingSoonZIndexOverlay}>
        <Typography style={styles.comingSoonText}>Coming Soon</Typography>
        <Typography style={styles.comingSoonSubtitle}>Downloads Data will be shown here</Typography>
      </div>
      {chart}
    </div>
  );
};

export default LineChart;
